const Link = {
  product: {
    label: '产品文档',
    url: 'https://cloud.tencent.com/document/product/269/1499#.E7.BE.A4.E7.BB.84.E5.8A.9F.E8.83.BD',
  },
  customMessage: {
    label: '自定义消息',
    url: 'https://web.sdk.qcloud.com/im/doc/v3/zh-cn/SDK.html#createCustomMessage',
  },
  complaint: {
    label: '点此投诉',
    url: 'https://cloud.tencent.com/apply/p/xc3oaubi98g',
  },
  implement: {
    label: '集成TUICallKit',
    url: 'https://cloud.tencent.com/document/product/269/79861',
  },
  purchase: {
    label: '开通腾讯实时音视频服务',
    url: 'https://cloud.tencent.com/document/product/1640/79968',
  },
};
export default Link;